(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  var bars = document.querySelectorAll('[data-announce-bar]');
  bars.forEach(function(bar) {
    var track  = bar.querySelector('[data-announce-track]');
    if (!track) return;
    var mode = bar.getAttribute('data-mode') || 'rotate';

    // Marquee mode: clone the track contents once for seamless loop, set animation speed.
    if (mode === 'marquee') {
      var inner = bar.querySelector('[data-marquee-inner]');
      if (!inner) return;
      // Skip cloning if the only content is the placeholder
      var realSlides = inner.querySelectorAll('[data-announce-slide]:not(.announce-slide--placeholder)');
      if (realSlides.length === 0) return;
      var clone = inner.cloneNode(true);
      clone.removeAttribute('data-marquee-inner');
      clone.setAttribute('aria-hidden', 'true');
      // Move children out of inner+clone into a single flex container
      var combined = document.createElement('div');
      combined.className = 'announce-marquee-track';
      while (inner.firstChild)  combined.appendChild(inner.firstChild);
      while (clone.firstChild)  combined.appendChild(clone.firstChild);
      inner.parentNode.replaceChild(combined, inner);
      var speed = parseFloat(bar.getAttribute('data-marquee-speed')) || 20;
      combined.style.animationDuration = speed + 's';
      return;
    }

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-announce-slide]'));
    if (slides.length <= 1) return;

    var idx = 0;
    var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
    var timer = null;
    var paused = false;

    function show(i) {
      slides.forEach(function(s, k) {
        if (k === i) s.classList.add('is-active');
        else s.classList.remove('is-active');
      });
    }
    function next() { idx = (idx + 1) % slides.length; show(idx); }
    function prev() { idx = (idx - 1 + slides.length) % slides.length; show(idx); }
    function start() { stop(); timer = setInterval(function() { if (!paused) next(); }, interval); }
    function stop()  { if (timer) { clearInterval(timer); timer = null; } }

    bar.addEventListener('mouseenter', function() { paused = true; });
    bar.addEventListener('mouseleave', function() { paused = false; });

    var btnNext = bar.querySelector('[data-announce-next]');
    var btnPrev = bar.querySelector('[data-announce-prev]');
    if (btnNext) btnNext.addEventListener('click', function() { next(); start(); });
    if (btnPrev) btnPrev.addEventListener('click', function() { prev(); start(); });

    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
  var grids = document.querySelectorAll('[data-pvr-grid]');
  if (!grids.length) return;

  grids.forEach(function(grid) {
    grid.querySelectorAll('[data-pvr-tile]').forEach(function(tile) {
      // Click-to-play path (deferred via <template>)
      var btn = tile.querySelector('[data-pvr-play]');
      var tpl = tile.querySelector('[data-pvr-video]');
      if (btn && tpl) {
        btn.addEventListener('click', function() {
          if (tile.hasAttribute('data-playing')) return;
          var node = tpl.content.firstElementChild;
          if (!node) return;
          var clone = node.cloneNode(true);
          tile.querySelector('.pvr-tile__media').appendChild(clone);
          tile.setAttribute('data-playing', '1');
          if (clone.tagName === 'VIDEO') clone.play().catch(function(){});
        });
      }

      // Autoplay path: sound toggle
      var soundBtn = tile.querySelector('[data-pvr-sound]');
      var autoVideo = tile.querySelector('[data-pvr-video-el]');
      if (soundBtn && autoVideo) {
        soundBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          var pressed = soundBtn.getAttribute('aria-pressed') === 'true';
          if (pressed) {
            autoVideo.muted = true;
            soundBtn.setAttribute('aria-pressed', 'false');
            soundBtn.setAttribute('aria-label', 'Включи звук');
          } else {
            // Mute all other autoplay videos on the page (only one with sound at a time)
            document.querySelectorAll('[data-pvr-video-el]').forEach(function(v) {
              if (v !== autoVideo) v.muted = true;
            });
            document.querySelectorAll('[data-pvr-sound]').forEach(function(b) {
              if (b !== soundBtn) {
                b.setAttribute('aria-pressed', 'false');
                b.setAttribute('aria-label', 'Включи звук');
              }
            });
            autoVideo.muted = false;
            // some browsers need play() after unmute to honor the user gesture
            autoVideo.play().catch(function(){});
            soundBtn.setAttribute('aria-pressed', 'true');
            soundBtn.setAttribute('aria-label', 'Спри звука');
          }
        });
        // Tapping the tile body also toggles sound
        tile.addEventListener('click', function(e) {
          if (e.target.closest('[data-pvr-sound]')) return;
          soundBtn.click();
        });
      }
    });
  });

  // Pause autoplay videos when off-screen (saves CPU/bandwidth)
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          v.play().catch(function(){});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.25 });
    document.querySelectorAll('[data-pvr-video-el]').forEach(function(v) { io.observe(v); });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
